/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProvisionType {
  SCIM_AUTO = 'scim_auto',
  SCIM_MANUAL = 'scim_manual',
  INVITE = 'invite',
}
